import { Star } from '@mui/icons-material'
import { Grid, Tooltip } from '@mui/material'
import React from 'react'
import { getI18n, useTranslation } from 'react-i18next'
import { ILinkedSkill, IWorkHistoryDetailsOther } from '../../../../interfaces/projects/IProjects'
import { OPAccordionItem } from '../../../Accordion/OPAccordionItem'
import { OPNewTable } from '../../../OPcomponents/OPNewTable'
import ProfileWorkHistoryForm from './ProfileWorkHistoryForm'

interface IProps {
  employersJobTitlesWorkHistory: IWorkHistoryDetailsOther[]
  loading: boolean
  onRowClick?: (id: number | string) => Promise<unknown>
  orderBy: string
  order: 'asc' | 'desc'
  onSortRequest: (headerText: string) => void
  allowAdd?: boolean // reserved for future add functionality
  userName?: string
}

const formatDateFi = (value?: string | Date | null): string => {
  if (!value) return ''
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return String(value)
  return d.toLocaleDateString('fi-FI')
}

const ProfileEmployersJobTitlesWorkHistory = ({
  employersJobTitlesWorkHistory,
  loading,
  onRowClick,
  orderBy,
  order,
  onSortRequest,
  userName,
}: IProps): JSX.Element => {
  const { t } = useTranslation()

  // Reuse header mapping logic; keys must match visible header text
  const rows = employersJobTitlesWorkHistory.map((work) => {
    const nameSuffix = userName ? `- ${userName}` : ''
    return {
      id: work.projectId,
      rows: {
        [t('Skills.EmployerJob')]: { text: work.projectName.replace(nameSuffix, ''), width: '25%' },
        [t('Projects.ProjectStartDate')]: { text: formatDateFi(work.empDetails?.[0]?.startDate), width: '12%' },
        [t('Projects.ProjectEndDate')]: { text: formatDateFi(work.empDetails?.[0]?.endDate), width: '12%' },
        [t('WorkHistory.Expirience')]: { text: `${work.daysWorked || 0} ${t('Date.ExperienceDays')}`, width: '12%' },
        [t('Projects.KeyEmployment')]: {
          text: work.isKeyProject ? <Star color='primary' /> : '',
          width: '9%',
          align: 'center' as const,
        },
        [t('WorkHistory.Skills')]: {
          text: (
            <Tooltip
              title={work.linkedSkills
                .map((s: ILinkedSkill) => (getI18n().language === 'en' && s.skillNameEng?.length ? s.skillNameEng : s.skillNameFi))
                .join(', ')}
              placement='bottom'
              arrow
            >
              <span>{work.linkedSkills.length}</span>
            </Tooltip>
          ),
          width: '10%',
        },
      },
    }
  })

  return (
    <Grid item xs={12}>
      <OPAccordionItem
        title={`${t('WorkHistory.EmployersJobTitlesHeader')} (${loading ? '\u2026' : employersJobTitlesWorkHistory.length})`}
        content={
          <Grid container className='gridcontainer--formcontainer__addnewpaddings'>
            <Grid item xs={12}>
              {rows.length ? (
                <OPNewTable
                  rows={rows}
                  curLength={rows.length}
                  onRowClick={onRowClick}
                  orderByControlled={orderBy}
                  orderControlled={order}
                  onSortRequest={onSortRequest}
                  FormBase={ProfileWorkHistoryForm}
                />
              ) : (
                <p className='profile--deptext profpadding'>{t('WorkHistory.NoEmployersJobTitles')}</p>
              )}
            </Grid>
          </Grid>
        }
      />
    </Grid>
  )
}

export default ProfileEmployersJobTitlesWorkHistory
